import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import { isNotificationAudioEnabled, setNotificationAudioEnabled as persistNotificationAudioEnabled } from "../utils/notificationAudio";

const NotificationAudioContext = createContext(null);

export function NotificationAudioProvider({ children }) {
  const [notificationAudioEnabled, setNotificationAudioEnabled] = useState(() => isNotificationAudioEnabled());

  const toggleNotificationAudio = useCallback(() => {
    setNotificationAudioEnabled((prev) => {
      const next = !prev;
      persistNotificationAudioEnabled(next);
      return next;
    });
  }, []);

  const value = useMemo(
    () => ({ notificationAudioEnabled, toggleNotificationAudio }),
    [notificationAudioEnabled, toggleNotificationAudio]
  );

  return (
    <NotificationAudioContext.Provider value={value}>
      {children}
    </NotificationAudioContext.Provider>
  );
}

export function useNotificationAudio() {
  const ctx = useContext(NotificationAudioContext);
  if (!ctx) {
    throw new Error("useNotificationAudio must be used within NotificationAudioProvider");
  }
  return ctx;
}
